import React from 'react/addons';
import {PureRenderMixin} from 'react/addons';

const PrestayContentSection = React.createClass({
  mixins: [PureRenderMixin],

  render() {
    var {children, title} = this.props;

    return (
    <div className="ofs-ContentSection">
      <div className="ofs-ContentSection__Wrapper ofs-ContentSection__Wrapper--narrow">
        <h2 className="ofs-ContentSection__Title">{title}</h2>
        <div className="ofs-ContentSection__Content">
          {children}
        </div>
      </div>
    </div>
    );
  },
});

export default PrestayContentSection;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/views/PrestayContentSection.jsx
 **/